import { isoly } from "isoly";
import { StateEditor } from "../StateEditor";
import { add } from "./base";
class Handler {
    currency;
    toInteger;
    constructor(options) {
        this.currency = options && typeof options == "object" ? options.currency : options;
        this.toInteger = options && typeof options == "object" ? options.toInteger : undefined;
    }
    toString(data) {
        return typeof data == "number" ? (isNaN(data) ? "" : data.toString()) : "";
    }
    fromString(value) {
        const result = typeof value == "string" ? Number.parseFloat(value) : undefined;
        return result != undefined && !isNaN(result) ? result : undefined;
    }
    partialFormat(unformatted) {
        let result = unformatted.value == "NaN" ? unformatted.replace(0, unformatted.value.length, "") : StateEditor.copy(unformatted);
        const decimals = this.currency && isoly.Currency.decimalDigits(this.currency);
        result = this.addLeadingIntegerZero(result);
        result = this.fillDecimalsIfPresent(result, decimals, "onlyLimit");
        result = this.truncateIntegerZeros(result);
        result = this.addThousandSeparators(result);
        return {
            ...result,
            remainder: this.format(unformatted).value.slice(result.value.length),
            type: "text",
            inputmode: "numeric",
            length: [3, undefined],
            pattern: new RegExp("^(\\d{0,3})( \\d{3})*(\\.\\d*)?$"),
        };
    }
    format(unformatted) {
        let result = unformatted.value == "NaN" ? unformatted.replace(0, unformatted.value.length, "") : StateEditor.copy(unformatted);
        const decimals = this.currency && isoly.Currency.decimalDigits(this.currency);
        if (!this.toInteger)
            result = this.forceDecimalZero(result, decimals);
        result = this.addLeadingIntegerZero(result);
        result = this.fillDecimalsIfPresent(result, decimals, "fillAndLimit");
        result = this.truncateIntegerZeros(result);
        result = this.addThousandSeparators(result);
        result = this.appendCurrency(result);
        return {
            ...result,
            type: "text",
            inputmode: "numeric",
            length: [3, undefined],
            pattern: new RegExp("^(\\d{0,3})( \\d{3})*(\\.\\d+)?" + (this.currency ? " " + this.currency : "") + "$"),
        };
    }
    forceDecimalZero(state, decimals) {
        if (!state.value.includes(".") && decimals && (Math.abs(Number.parseFloat(state.value)) >= 0 || state.value == "0"))
            state = state.suffix(".0");
        return state;
    }
    addLeadingIntegerZero(state) {
        const separatorIndex = state.value && state.value.includes(".") ? state.value.indexOf(".") : undefined;
        if (separatorIndex == 0)
            state = state.prepend("0");
        return state;
    }
    fillDecimalsIfPresent(state, decimals, zeroHandling) {
        const separatorIndex = state.value.indexOf(".");
        if (separatorIndex != -1) {
            const adjust = separatorIndex + 1 + (decimals ?? 2) - state.value.length;
            state =
                adjust < 0
                    ? state.truncate(state.value.length + adjust)
                    : zeroHandling == "fillAndLimit"
                        ? state.suffix("0".repeat(adjust))
                        : state;
        }
        return state;
    }
    truncateIntegerZeros(state) {
        const match = state.match(/^[0\s]{2,}/);
        if (match)
            state = state.replace(0, match[0].length, "0");
        return state;
    }
    addThousandSeparators(state) {
        let separatorIndex = state.value.includes(".") ? state.value.indexOf(".") : state.value.length;
        const spaces = separatorIndex <= 0 ? 0 : Math.ceil(separatorIndex / 3) - 1;
        for (let i = 0; i < spaces; i++) {
            const position = separatorIndex - (spaces - i) * 3;
            state = state.insert(position, " ");
            separatorIndex++;
        }
        return state;
    }
    appendCurrency(state) {
        return this.currency && (state.value.length > 1 || (state.value.length == 1 && state.value.charAt(0) != "."))
            ? state.suffix(" " + this.currency)
            : state;
    }
    unformat(formatted) {
        return this.currency ? formatted.delete(" ").delete("" + this.currency) : formatted.delete(" ");
    }
    allowed(symbol, state) {
        return ((symbol >= "0" && symbol <= "9") ||
            (symbol == "." &&
                !state.value.includes(".") &&
                (!this.currency || isoly.Currency.decimalDigits(this.currency) != 0)));
    }
}
add("price", (argument) => new Handler(argument && argument.length > 0 ? argument[0] : undefined));
//# sourceMappingURL=price.js.map